import {AfterViewInit, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {ScrollPositionService} from '../../services/scroll-position.service';
import {Meta, Title} from '@angular/platform-browser';
import {KenticoService} from '../../services/kentico.service';

declare var AOS: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit {

  constructor(private spService: ScrollPositionService,
              private kenticoService: KenticoService,
              meta: Meta,
              title: Title) {
    const metadata = {
      title: 'Gridhaus',
      description: 'Welcome to Gridhaus. We elevate brands & businesses through strategy & design made for the digital world.'
    };
    meta.addTags([
      {name: 'description', content: metadata.description},
      {name: 'twitter:card', content: 'summary_large_image'},
      {name: 'twitter:title', content: metadata.title},
      {name: 'twitter:description', content: metadata.description},
      {property: 'og:title', content: metadata.title},
      {property: 'og:description', content: metadata.description},
    ]);
  }

  ngOnInit() {
    // this.kenticoService.getProjects().subscribe(projects => {
    //   console.log(projects[0].title.value);
    // });
  }

  ngAfterViewInit() {
    AOS.refreshHard();
    this.spService.autoScroll();
  }

  scrollPastHero() {
    this.spService.scrollPastHero();
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/pages/home/home.component.ts